// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1tlgV","image":"Header_image__3j5cz","name":"Header_name__1VMuQ","info":"Header_info__2gB1p","infoRow":"Header_infoRow__1v5c4"};